<template>
  <div class="app-container exam-detail">
    <basic-container>
      <avue-tabs :option="option" @change="handleChange"></avue-tabs>
      <span v-show="type.prop==='tab1'">
        <h4>基本信息</h4>
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#FAFAFA'}"
          border>
          <el-table-column
            prop="title"
            label="考试名称">
          </el-table-column>
          <el-table-column
            prop="description"
            label="考试描述">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
          </el-table-column>
        </el-table>
        <br>
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#FAFAFA'}"
          border>
          <el-table-column
            prop="category"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="startedTime"
            label="开始时间">
          </el-table-column>
          <el-table-column
            prop="endedTime"
            label="结束时间">
          </el-table-column>
          <el-table-column
            prop="duration"
            label="考试时长（分钟）">
          </el-table-column>
          <el-table-column
            prop="limitTimes"
            label="考试次数">
          </el-table-column>
        </el-table>
        <br>
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#FAFAFA'}"
          border>
          <el-table-column
            label="试卷名">
            <template slot-scope="scope">
              <a style="color: blue;" @click="toPaper(scope.row)">{{ scope.row.paperPrototype.title }}</a>
            </template>
          </el-table-column>
          <el-table-column
            label="参与范围">
            <template slot-scope="scope">
              <div v-if="JSON.stringify(scope.row.attendeeScopeInfo) != '{}'">
                <span v-if="scope.row.attendeeScopeInfo.memberList">{{ scope.row.attendeeScopeInfo.memberList.length }} 人 </span> &nbsp;&nbsp; 
                <span v-if="scope.row.attendeeScopeInfo.tagList">{{ scope.row.attendeeScopeInfo.tagList.length }} 个标签 ( 人)</span>
              </div>
              <div v-else>
                <el-tag class="all-tag" size="medium">全部</el-tag>
                <el-tooltip class="item" effect="dark" content="此考试所有人员均可参与" placement="top">
                  <sup><i class="el-icon-question"></i></sup>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="paperPrototype.totalScore"
            label="试卷总分">
          </el-table-column>
        </el-table>
      </span>
      <span v-show="type.prop==='tab2'">
        <avue-crud
          ref="crud"
          :option="resultTableOption"
          :data="resultData"
          :page="page"
          :table-loading="tableLoading"
          :before-open="handleOpenBefore"
          @refresh-change="getRecord"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange">
        </avue-crud>
      </span>
    </basic-container>
  </div>
</template>
<script>
import { getExamDetail, getRecord } from '@/api/app/exam'
import { examStatusOption, examCategoryOption, examResultTableOption } from '@/const/crud/app/exam';
export default {
  data() {
    return {
      examStatusOption,
      resultTableOption: examResultTableOption,
      detail: {},
      type:{},
      option:{
        column: [{
          icon:'el-icon-info',
          label: '详情',
          prop: 'tab1',
        }, {
          icon:'el-icon-tickets',
          label: '统计',
          prop: 'tab2',
        }]
      },
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
      },
      tableData: [],
      resultData: [],
      tableLoading: false,
    }
  },
  created(){
    this.type = this.option.column[0];
  },
  mounted () {
    this.id = this.$route.params.id
    this.getDetail();
    this.getRecord();
  },
  methods:{
    handleChange(column) {
      this.type = column
    },
    getDetail() {
      getExamDetail(this.id).then(res => {
        this.detail = this.formatData(res.data.data)
        this.tableData.push(this.detail)
      }).catch(error => {
        this.$message({
          message: '获取考试详情失败',
          type: 'error'
        })
      })
    },
    getRecord(){
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        examId: this.id
      }
      this.tableLoading = true
      getRecord(params).then(res => {
        this.resultData = this.formatResultData(res.data.data.records)
        this.page.total = res.data.data.total
        this.tableLoading = false
      }).catch(error => {
        this.$message({
          message: '获取考试结果失败',
          type: 'error'
        })
      })
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.getList()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getList()
    },
    formatResultData(list) {
      list.forEach(item => {
        item.pass = item.pass ? '通过' : '未通过'
      });
      return list
    },
    formatData(obj) {
      if(!this.validatenull(obj.status))
        obj.status = examStatusOption.find((v) => (v.value == obj.status)).label;
      if(!this.validatenull(obj.category))
        obj.category = examCategoryOption.find((v) => (v.value == obj.category)).label;
      obj.duration = obj.duration === 0 ? '不限时' : Math.floor(obj.duration / 60)
      return obj
    },
    toPaper(row) {
      this.$router.push({
        path: `/app/exam/paper/show/${row.paperPrototypeId}`
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .exam-detail{
    .detail-header{
      background-color: #f5f5f5;
    }
    .desc{
      word-wrap:break-word;
      word-break:normal;
    }
    .exam-permission, .tag-name-wrapper{
      margin-right: 10px;
    }
    .exam-permission span{
      margin-right: 5px;
    }

    .all-tag{
      margin-right: 5px;
    }
    .el-icon-question{
      font-size: 15px;
      cursor: pointer
    }
  }
</style>
